module.exports = __webpack_public_path__ + "img/energy004.53488f91.png";